import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';
import { ApiResponse } from '../interfaces/responses/ApiResponse';

// Age verification now lives on HeavyDutyMachineryApi's own AgeVerificationController.
const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export interface IAgeVerificationStatus {
  required: boolean;
  verified: boolean;
  verifiedAt: string | null;
}

export interface IAgeVerificationSession {
  sessionToken: string;
  qrValue: string;
  expiresAt: string;
}

// Set right after registration when the application requires this step
// (see IRegisterResponse.requireAgeVerification); cleared once
// AgeVerification.tsx confirms the backend says verified. Read by
// ProtectedRoute to force new accounts through /verify-age before
// anything else in the app.
export const PENDING_AGE_VERIFICATION_KEY = 'pendingAgeVerification';

export const getAgeVerificationStatus = async (): Promise<IAgeVerificationStatus> => {
  const response = await apiService<ApiResponse<IAgeVerificationStatus>>({
    url: API_ENDPOINTS.AGE_VERIFICATION_STATUS,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data.data;
  throw new Error(response.error || 'Failed to load age verification status');
};

// Starts a new verification attempt — the caller renders `qrValue` as a QR
// code (see AgeVerification.tsx) and polls getAgeVerificationStatus() while
// waiting for it to be scanned and confirmed.
export const createAgeVerificationSession = async (): Promise<IAgeVerificationSession> => {
  const response = await apiService<ApiResponse<IAgeVerificationSession>>({
    url: API_ENDPOINTS.AGE_VERIFICATION_SESSION,
    method: HTTP_METHODS.POST,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data.data;
  throw new Error(response.error || 'Failed to start age verification');
};
